import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import FileUpload from "../../components/FileUpload/FileUpload";
import { Formik, Field, Form, ErrorMessage } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Button,
} from "reactstrap";

import "react-datepicker/dist/react-datepicker.css";

import { addAlert, getClubs } from "store/actions";

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import moment from "moment";
import Switch from "components/Common/Switch";

class AddAlert extends Component {
  constructor() {
    super();
    this.state = {
      clubError: false,
      clubsSelected: [],
      clubsFiltered: [],
      sendPushNotification: false,
    };
    this.handleMultiClub = this.handleMultiClub.bind(this);
  }

  filterClubs = () => {
    const { clubs } = this.props;
    return clubs.map(item => ({ label: item.name, value: item.id }));
  };

  componentDidMount() {
    const { onGetClubs } = this.props;
    onGetClubs();
    this.setState({
      clubsFiltered: [
        {
          label: "Clubs",
          options: this.filterClubs(),
        },
      ],
    });
  }

  handleSendNotification = () => {
    this.setState({
      sendPushNotification: !this.state.sendPushNotification,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { clubs } = this.props;
    if (clubs !== prevProps.clubs) {
      this.setState({
        clubsFiltered: [
          {
            label: "Clubs",
            options: this.filterClubs(),
          },
        ],
      });
    }
  }

  handleMultiClub = clubsSelected => {
    this.setState({ clubsSelected, clubError: false });
  };

  render() {
    const { clubsFiltered, clubsSelected } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Add app alert | Groundfloor</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="App alert" breadcrumbItem="Add New" />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <CardTitle className="mb-4">Add new app alert</CardTitle>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        title: "",
                        description: "",
                        expirationDate: "",
                      }}
                      validationSchema={Yup.object().shape({
                        title: Yup.string().required("Please Enter Title"),
                        description: Yup.string().required(
                          "Please Enter Description"
                        ),
                        expirationDate: Yup.string().required(
                          "Please enter expiration date"
                        ),
                      })}
                      onSubmit={values => {
                        if (clubsSelected.length === 0) {
                          this.setState({
                            clubError: true,
                          });
                        } else {
                          clubsSelected.map(item => {
                            this.props.onAddAlert({
                              title: values.title,
                              description: values.description,
                              clubId: parseInt(item.value),
                              sendPushNotification:
                                this.state.sendPushNotification,
                              expirationDate: moment(
                                values.expirationDate
                              ).format("YYYY-MM-DD"),
                            });
                          });

                          setTimeout(() => {
                            this.props.history.goBack();
                          }, 1500);
                        }
                      }}
                    >
                      {({ errors, status, touched }) => (
                        <React.Fragment>
                          <Form>
                            <Row className="mb-4">
                              <Label
                                htmlFor="name"
                                className="col-form-label col-lg-2"
                              >
                                Title
                              </Label>
                              <Col lg="10">
                                <Field
                                  name="title"
                                  type="text"
                                  placeholder="Title"
                                  className={
                                    "form-control" +
                                    (errors.title && touched.title
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="title"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </Row>
                            <Row className="mb-4">
                              <Label
                                htmlFor="name"
                                className="col-form-label col-lg-2"
                              >
                                Expiration Date
                              </Label>
                              <Col lg="10">
                                <Field
                                  name="expirationDate"
                                  type="date"
                                  className={
                                    "form-control" +
                                    (errors.expirationDate &&
                                    touched.expirationDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="expirationDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </Row>
                            <Row className="mb-4">
                              <Label
                                htmlFor="duration"
                                className="col-form-label col-lg-2"
                              >
                                Select Club
                              </Label>
                              <Col lg="10">
                                <Select
                                  value={clubsSelected}
                                  isMulti={true}
                                  onChange={this.handleMultiClub}
                                  options={clubsFiltered}
                                  classNamePrefix="select2-selection"
                                />
                                {this.state.clubError && (
                                  <p
                                    style={{
                                      color: "red",
                                    }}
                                  >
                                    Please Select a Club
                                  </p>
                                )}
                              </Col>
                            </Row>

                            <Row className="mb-4">
                              <Label className="col-form-label col-lg-2">
                                Description
                              </Label>

                              <Col lg="10">
                                <Field
                                  name="description"
                                  component="textarea"
                                  rows="6"
                                  type="textarea"
                                  className={
                                    "form-control" +
                                    (errors.description && touched.description
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="description"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </Row>
                            <Row className="mb-4">
                              <Label
                                htmlFor="sendPushNotification"
                                className="col-form-label col-lg-2"
                              >
                                Send Push Notification
                              </Label>
                              <Col lg="10">
                                <Switch
                                  active={this.state.sendPushNotification}
                                  parentFunc={this.handleSendNotification}
                                />
                              </Col>
                            </Row>
                            <FormGroup className="mb-4" row>
                              <Label className="col-form-label col-lg-2">
                                Attach Image (Optional)
                              </Label>
                              <Col lg="10">
                                <FileUpload />
                              </Col>
                            </FormGroup>

                            <Row className="justify-content-end">
                              <Col lg="10">
                                <Button type="submit" color="primary">
                                  Add alert
                                </Button>
                              </Col>
                            </Row>
                          </Form>
                        </React.Fragment>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AddAlert.propTypes = {
  onAddAlert: PropTypes.func,
  history: PropTypes.object,
  onGetClubs: PropTypes.func,
  clubs: PropTypes.array,
};

const mapStateToProps = ({ system }) => ({
  clubs: system.clubs,
});

const mapDispatchToProps = dispatch => ({
  onGetClubs: () => dispatch(getClubs()),
  onAddAlert: alert => dispatch(addAlert(alert)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AddAlert));
